export default __webpack_public_path__ + "img/done-icon-light.png";